module.exports = __webpack_public_path__ + "img/symbol_hashblue.12e0bdc1.png";